import React from "react";
import { STATS } from "./data";
import { useCountUp } from "../../hooks/useCountUp";

/**
 * Section ③ — Stats Bar. Cream background, espresso editorial numerals,
 * warm stone labels. Four equal columns separated by thin wine dividers.
 * Counts up on enter.
 */
const Stat = ({ s, last }) => {
  const [ref, current] = useCountUp(s.numeric, 1200);
  // Locale-format for Indian digit grouping (₹2,400 etc.). 8 and 12 stay as plain.
  const formatted = Math.round(current).toLocaleString("en-IN");
  return (
    <div
      ref={ref}
      className={`text-center ${
        !last ? "lg:border-r lg:border-[rgba(10,55,40,0.10)]" : ""
      }`}
      style={{
        paddingTop: 60,
        paddingBottom: 60,
        paddingLeft: 48,
        paddingRight: 48,
      }}
      data-testid={`stat-item-${s.label}`}
    >
      <div
        data-testid="stat-value"
        style={{
          fontFamily: "'Cormorant Garamond', Georgia, serif",
          fontWeight: 300,
          fontSize: "clamp(54px, 5vw, 68px)",
          lineHeight: 1,
          letterSpacing: "-0.02em",
          color: "#0A0A0A",
          marginBottom: 18,
          whiteSpace: "nowrap",
        }}
      >
        {s.prefix}
        {formatted}
        {s.suffix}
      </div>
      <div
        className="uppercase whitespace-pre-line"
        style={{
          fontFamily: "'Jost', sans-serif",
          fontWeight: 400,
          fontSize: 9,
          letterSpacing: "0.44em",
          color: "#8C7E6A",
          lineHeight: 1.7,
        }}
      >
        {s.label}
      </div>
    </div>
  );
};

const StatsBar = () => {
  return (
    <section
      className="relative"
      style={{
        backgroundColor: "#FAF6EF",
        borderTop: "1px solid rgba(10,55,40,0.12)",
        borderBottom: "1px solid rgba(10,55,40,0.12)",
      }}
      data-testid="stats-bar"
    >
      <div className="max-w-[1440px] mx-auto grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Stat key={s.label} s={s} last={i === STATS.length - 1} />
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
